
import { loadJS } from '@/libs/async-load.js';
import { formatImageSrc } from '@xd-rocket/utils/base';

export default {
  name: 'WidgetDefaultNuxt',
  props: {
    nodeId: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    file: {
      type: Object,
      default: () => ({}),
    },
    widgetApi: {
      type: Object,
      default: () => ({}),
    },
    values: {
      type: Object,
      default: () => ({}),
    },
    $bus: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const { values, file } = this;

    let baseLocalePath = [];
    let staticEvent =
      !!values.static?.event && !this.values.trackBehavior?.isReport; // 无事件及统计
    let staticI18n = !!values.static?.i18n;
    if (!staticI18n) {
      if (values.class) {
        baseLocalePath.push({
          key: 'customClass',
          value: values.class,
          update: this.filterCustomClass,
        });
      }
    }
    return {
      ossImgRatio: file.pureInfo.ossImgRatio,
      widgetClassName: '',
      forceVisible: 0,
      localeStyles: {},
      localePath: [],
      baseLocalePath,
      eventMap: {},
      localePathMap: [],
      localeStylesPathMap: [],
      triggerMap: {},
      cssFromEvent: {},
      extendStyle: {},
      isLazyLoad: values.type === 'WidgetRoundedRect' && !!values.isLazyLoad,
      timer: null,
      startTime: 0,
      endTime: 0,
      stopEventBubble: !!values.stopEventBubble,
      customClass: this.filterCustomClass(
        this.getLocaleValue(values.class) || []
      ),
      staticEvent,
      staticI18n,
    };
  },
  computed: {
    classFromCustom() {
      const { customClass, cssFromEvent } = this;
      let result = { ...customClass, ...cssFromEvent };
      return result;
    },
    classes() {
      const { widgetClassName, forceVisible, classFromCustom } = this;
      let result = this.values.sysClass ?? {};
      result = { ...classFromCustom, ...result };
      if (forceVisible < 0) {
        result['rocket-hide'] = true;
      } else if (forceVisible) {
        result['rocket-show'] = true;
      }
      if (widgetClassName) result[widgetClassName] = true;
      return result;
    },
    haveLocalePath() {
      return this.localePathMap.length > 0;
    },
    haveLocaleStyles() {
      return this.localeStylesPathMap.length > 0;
    },
    widgetListener() {
      if (this.staticEvent) return this.$listeners;
      return {
        ...this.$listeners,
        click: this.handleTap,
      };
    },
  },
  created() {
    this.initLocaleStyles(); // 避免绑定数据池的背景图片赋值太晚，导致轮播图循环时复制的不正确
  },
  beforeMount() {
    if (!this.staticEvent) {
      // rocket:node:trigger 用于统一监听来自组件以外的触发,比如来自事件编辑器的动作
      this.$bus.$on(
        'rocket:node:trigger:' + this.nodeId,
        this.handleEventTrigger
      );
    }
  },
  mounted() {
    this.updateLocalePathMap(); // mounted 之后立刻修改数据池，所以这里要立刻执行
    if (!this.staticEvent) {
      if (this.initEvent) this.initEvent();
      this.initBaseEvent();
    }
  },
  beforeDestroy() {
    const { eventMap } = this;
    Object.keys(eventMap).map((k) => {
      let arr = eventMap[k];
      arr.map((item) => {
        this.$bus.$off(k, item.handler || item.cb);
      });
      eventMap[k] = [];
    });
    this.eventMap = {};
    this.triggerMap = {};
    if (!this.staticEvent) {
      this.$bus.$off(
        'rocket:node:trigger:' + this.nodeId,
        this.handleEventTrigger
      );
    }
    if (this.watchImages?.size) {
      this.clearWatchImages();
    }
    if (this.observer) this.observer.disconnect();
    if (this.observerHalf) this.observerHalf.disconnect();
    if (this.observerFull) this.observerFull.disconnect();
  },
  methods: {
    initBaseEvent() {
      this.$nextTick(() => {
        this.rocketOn(
          'rocket:node:pause-animation',
          true,
          this.handleRemoveAnimateCls
        );
        this.rocketOn(
          'rocket:system:create-screenshot',
          true,
          this.createScreenshot
        );
      });

      this.rocketOn('rocket:system:show', true, this.handleShow);
      this.rocketOn('rocket:system:hide', true, this.handleHide);
      this.rocketOn('rocket:node:get', true, this.handleGetElement);
      this.rocketOn('rocket:system:change-style', true, this.handleChangeStyle);
      this.rocketOn('rocket:node:add-css-class', true, this.handleAddCls);
      this.rocketOn('rocket:node:remove-css-class', true, this.handleRemoveCls);
      this.rocketOn('rocket:node:toggle-css-class', true, this.handleToggleCls);
      this.rocketOn(
        'rocket:node:play-animation',
        true,
        this.handleAddAnimateCls
      );
      if (this.haveLocaleStyles || this.haveLocalePath) {
        this.rocketOn(
          'rocket:system:after-update-locale',
          false,
          this.afterUpdateLocale
        );
      }

      // 因为有些监听注册的时机较晚，需要预留一点时间运行
      this.$nextTick(() => {
        this.rocketOn('rocket:node:scroll-top-to', true, (num) => {
          this.$el.scrollTop = num;
        });
        this.rocketOn('rocket:node:get-offset-top', true, (type) => {
          let ret = null;
          if (type === 'parent' && this.$el?.offsetTop) {
            ret = this.$el.offsetTop;
          } else if (type === 'document' && this.$el) {
            let ele = this.$el;
            do {
              ret += ele.offsetTop;
              ele = ele.offsetParent;
            } while (ele && ele !== document.body);
          }
          this.rocketEmit('rocket:node:get-offset-top-success', true, ret);
        });
        setTimeout(() => {
          if (
            this.$bus._events['rocket:system:scroll-observe:' + this.values.id]
          ) {
            this.observer = new IntersectionObserver(
              ([entry]) => {
                this.rocketEmit(
                  'rocket:system:scroll-observe',
                  true,
                  entry.isIntersecting
                );
              },
              { threshold: 0 }
            );
            this.observer.observe(this.$el);
          }
        }, 50);
      });

      if (
        this.$bus._events['rocket:system:scroll-observe-half:' + this.values.id]
      ) {
        this.observerHalf = new IntersectionObserver(
          ([entry]) => {
            this.rocketEmit(
              'rocket:system:scroll-observe-half',
              true,
              entry.isIntersecting
            );
          },
          { threshold: 0.5 }
        );
        this.observerHalf.observe(this.$el);
      }

      if (
        this.$bus._events['rocket:system:scroll-observe-full:' + this.values.id]
      ) {
        this.observerFull = new IntersectionObserver(
          ([entry]) => {
            this.rocketEmit(
              'rocket:system:scroll-observe-full',
              true,
              entry.isIntersecting
            );
          },
          { threshold: 1 }
        );
        this.observerFull.observe(this.$el);
      }

      // 监听长按
      if (this.values.isLongTouch) {
        this.$el.addEventListener('touchstart', this.handleTouchStart);
        this.$el.addEventListener('touchend', (e) => {
          this.handleTouchEnd(e, 'touch');
        });
        this.$el.addEventListener('mousedown', this.handleTouchStart);
        this.$el.addEventListener('mouseup', (e) => {
          this.handleTouchEnd(e, 'mouse');
        });
      }
    },
    handleEventTrigger(type, info, ...args) {
      if (info?.limit && this.$bus.callback.checkLimit(info.limit, this))
        return;
      else if (info?.id && this.id !== info.id) return; // 如果提供了 id

      if (type === 'rocket:node:lazy-load-start') {
        this.loadLazyImages();
      } else {
        if (!this.triggerMap[type]?.length) return;
        this.triggerMap[type].map((cb) => cb(...args));
      }
    },
    // 监听事件编辑器的触发动作
    // 如果属于当前组件在代码中的对自己的监听行为，会使用 rocket:node:trigger 进行监听，以便进行监听的汇总，并防止自己监听自己触发的死循环
    rocketOn(event, limit, cb) {
      if (limit) {
        if (!this.triggerMap[event]) this.triggerMap[event] = [];
        this.triggerMap[event].push(cb);
        return;
      }
      this.$bus.$on(event, cb);
      if (!this.eventMap[event]) this.eventMap[event] = [];
      this.eventMap[event].push({ cb });
    },
    // 触发事件编辑器的监听
    rocketEmit(event, limit, ...args) {
      let eventName = event;
      if (limit) {
        eventName = event + ':' + this.nodeId;
        // 触发事件编辑器监听时，需要传入当前节点，以便事件编辑器判断是否需要触发
        args.unshift(this);
      }
      this.$bus.$emit(eventName, ...args);
    },
    rocketOff(event, limit, cb) {
      let eventName = event;
      if (limit) {
        eventName = event + ':' + this.nodeId;
      }
      if (!cb) {
        // 移除本节点上此类事件的所有监听
        // 移除整个页面的指定事件，可以直接用 $bus.$off(evenName)
        if (this.eventMap[eventName]) {
          let arr = this.eventMap[eventName];
          arr.map((item) => {
            this.$bus.$off(eventName, item.handler || item.cb);
          });
          this.eventMap[eventName] = [];
        }
      } else {
        if (!this.eventMap[eventName]?.length) return;
        // 移除指定的监听事件
        this.eventMap[eventName] = this.eventMap[eventName].filter((item) => {
          if (item.cb === cb) {
            this.$bus.$off(eventName, item.handler || item.cb);
            return false;
          }
          return true;
        });
      }
    },
    handleShow() {
      this.forceVisible = 1;
    },
    handleHide() {
      this.forceVisible = -1;
    },
    handleGetElement(cb) {
      if (typeof cb === 'function') {
        cb(this);
      }
    },
    handleChangeStyle(style) {
      let element = this.$el;
      if (element && style && Object.keys(style).length != 0) {
        Object.keys(style).forEach((key) => {
          element.style[key] = style[key];
        });
      }
    },
    // 字符串，数组
    filterCustomClass(data, v = true) {
      let result = {};
      if (!data) return result;
      if (typeof data === 'string') {
        result[data] = v;
      } else if (Array.isArray(data)) {
        data.forEach((k) => {
          if (k && typeof k === 'string') result[k] = v;
        });
      }
      return result;
    },
    handleAddCls(v) {
      let obj = this.filterCustomClass(v);
      this.cssFromEvent = { ...this.cssFromEvent, ...obj };
    },
    handleRemoveCls(v) {
      let obj = this.filterCustomClass(v, false);
      this.cssFromEvent = { ...this.cssFromEvent, ...obj };
    },
    handleToggleCls(v) {
      let obj = this.filterCustomClass(v);
      let keys = Object.keys(obj);
      if (!keys.length) return;
      keys.forEach((k) => {
        const state = !!this.classes[k];
        this.cssFromEvent = { ...this.cssFromEvent, [k]: !state };
      });
    },
    handleAddAnimateCls(
      name,
      duration,
      delay,
      count,
      direction,
      easing,
      fillMode
    ) {
      let element = this.$el;
      element.style['animation'] = 'unset';
      const style = {
        'animation-name': name,
        'animation-duration': duration + 'ms',
        'animation-iteration-count': count,
        'animation-play-state': 'running',
      };
      if (direction !== 'normal') {
        style['animation-direction'] = direction;
      }
      if (delay > 0) {
        style['animation-delay'] = delay + 'ms';
      }
      if (fillMode !== 'none') {
        style['animation-fill-mode'] = fillMode;
      }
      if (easing !== 'ease') {
        style['animation-timing-function'] = easing;
      }
      if (element) {
        Object.keys(style).forEach((key) => {
          element.style[key] = style[key];
        });
      }
    },
    handleRemoveAnimateCls(name) {
      let element = this.$el;
      if (element) {
        if (element.style['animation-name'] === name) {
          element.style['animation-play-state'] = 'paused';
        }
      }
    },
    getLocaleValue(v) {
      return this.$i18n.r(v, this.values.dataInject);
    },
    handleTap(e) {
      this.handleStopPropagation(e);
      this.rocketEmit('rocket:system:tap', true);
    },
    handleStopPropagation(e) {
      if (this.stopEventBubble) {
        e.stopPropagation();
      }
    },
    // 获取真实的数据池映射路径
    getLocalePathConfig(conf) {
      let value = conf?.value;
      if (!value) return null;
      let path = this.$i18n.rp(value, this.values.dataInject);
      if (path.length) {
        return { ...conf, path, value };
      }
      return null;
    },
    clearLocalePathEvent(arr) {
      if (!arr) return;
      arr.map((o) => {
        let watch = o.watch;
        if (!watch?.length) return;
        watch.map((i) =>
          this.rocketOff(
            'rocket:system:after-update-i18n:' + i.name,
            false,
            i.cb
          )
        );
      });
    },
    // 根据事件编辑器中对数据池的修改动作，来判断哪些路径需要监听
    initLocalePathEvent(arr = []) {
      let result = [];
      if (!arr.length) return result;

      const pathNeedWatch = this.file.pathNeedWatch; // 可能触发修改的路径

      arr.map((o) => {
        let conf = { ...o };
        if (!conf.path) {
          conf = this.getLocalePathConfig(o);
        }
        if (!conf) return;
        result.push(conf);
        if (!pathNeedWatch.length) return;
        let path = conf.path;
        let tmp = [];
        let watch = [];
        for (let i = 0, l = path.length; i < l; i++) {
          tmp.push(path[i]);
          let name = tmp.join('.');
          // 在修改影响范围内
          if (pathNeedWatch.indexOf(name) > -1) {
            let cb = () => this.afterUpdateI18n(conf);
            watch.push({ name, cb });
            this.rocketOn('rocket:system:after-update-i18n:' + name, false, cb);
          }
        }
        if (watch.length) conf.watch = watch;
      });
      return result;
    },
    // 更新节点属性中与数据池有关的字段映射表
    updateLocalePathMap() {
      this.clearLocalePathEvent(this.localePathMap);
      this.localePathMap = [];

      const { localePath, baseLocalePath } = this;
      let arr = [...localePath, ...baseLocalePath];
      this.localePathMap = this.initLocalePathEvent(arr);
    },
    getStyles(styles, result = {}) {
      styles.map((v) => {
        result[v.attr] = v.value;
      });
      return result;
    },
    // 更新与数据池有关联的样式
    updateLocaleStyles(styles) {
      let result = {};
      if (styles) {
        result = this.getStyles(styles, { ...this.localeStyles });
      } else {
        if (!this.haveLocaleStyles) return {};
        const { localeStylesPathMap } = this;
        localeStylesPathMap.map((o) => {
          result = this.getStyles(o.styles, result);
        });
      }
      this.localeStyles = result;
    },
    initLocaleStyles() {
      // 计算受 dataSource 影响的模板的 i18n 样式
      // 目前 style 属性中涉及 i18n 的属性较少，基本没有互相引用关联，对父级节点也没有依赖, 所以先不进行深度的处理
      const { values } = this;
      let arr = [];
      let vars = values?.i18nStyleVars;
      if (!vars) return;
      const dataInject = values.dataInject;
      let styles = [];
      Object.keys(vars).map((k) => {
        let v = vars[k];
        let path = this.$i18n.rp(v, dataInject);
        let o = { value: v, key: k, isStyle: true, path };
        arr.push(o);
        if (this.nodeId !== this.id) {
          // 这里可能会导致初始化数据更新不及时，可以从 packages/rocket-attributes/src/modules/style.js 进行优化，完善编辑器生成样式的能力
          // 编辑器保存时暂时没有遍历所有节点包括列表的能力，未来应该会写一个中轴系统，虚拟出所有节点，在一个函数中，这样所有节点可以使用 v-if 数据从中轴获取。
          // 多语言背景图图片还是需要全量运行 afterUpdateI18n ，后期再看怎么优化
        }
        this.afterUpdateI18n(o);
      });
      this.updateLocaleStyles(styles); // 已经通过 css 先编译进入 html
      if (arr.length) {
        this.localeStylesPathMap = this.initLocalePathEvent(arr);
      }
    },
    // 更新数据池
    afterUpdateI18n(conf) {
      const isStyle = conf.isStyle;
      let v = this.$i18n.r({ i18n: conf.path });
      if (isStyle) {
        let styles = [];
        if (conf.key.indexOf('bg-image') > -1) {
          let o = formatImageSrc(v, this.ossImgRatio);
          v = `url(${o.src})`;
          if (o.isValid) {
            styles.push({ attr: conf.key + '-1x', value: `url(${o.src_1x})` });
          }
        }
        styles.push({ attr: conf.key, value: v });
        this.updateLocaleStyles(styles);
      } else {
        if (conf.update) this[conf.key] = conf.update(v);
        else this[conf.key] = v;
      }
    },
    async loadAllImages(container) {
      const imageElements = container.getElementsByTagName('img');
      const imagePromises = [];
      for (let i = 0; i < imageElements.length; i++) {
        const img = imageElements[i];
        let classList = img.classList;
        if (classList.contains('v-lazy-image')) {
          if (!classList.contains('v-lazy-image-loaded')) {
            continue;
          }
        }

        this.loadImage(img.currentSrc || img.src);
      }
      await Promise.all(imagePromises);
    },
    loadImage(src) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.onload = () => {
          img = null;
          resolve();
        };
        img.onerror = reject;
        img.src = src;
      });
    },
    // 切换语言后
    afterUpdateLocale() {
      if (this.haveLocaleStyles) {
        this.localeStylesPathMap.map((o) => this.afterUpdateI18n(o));
      }
      if (this.haveLocalePath) {
        this.localePathMap.map((o) => this.afterUpdateI18n(o));
      }
    },
    async createScreenshot(to_preload) {
      var scale = window.devicePixelRatio >= 2 ? window.devicePixelRatio : 2; //屏幕设备像素比
      const preview = this.$el;
      //截图前处理
      this.beforeShot(preview);
      try {
        if (to_preload) {
          await this.loadAllImages(preview);
        }
        await loadJS(
          'https://poster.xdcdn.net/poster/.system/js/html2Canvas.js'
        );
        window
          .html2canvas(preview, {
            scale,
            scrollY: 0,
            useCORS: true,
            height: preview.offsetHeight,
            width: preview.offsetWidth,
            backgroundColor: null,
          })
          .then((canvas) => {
            document
              .querySelectorAll('.html2canvas-container')
              .forEach((el) => {
                const iframe = el.contentWindow;
                if (el) {
                  el.src = 'about:blank';
                  iframe.document.write('');
                  iframe.document.clear();
                  iframe.close();
                  el.remove();
                }
              });
            var dataUrl = canvas.toDataURL('image/png');
            this.rocketEmit('rocket:system:screenshot-success', true, dataUrl);
            // 释放Canvas对象
            canvas.remove();
            canvas = null;
          });
      } catch (error) {
        this.rocketEmit('rocket:system:screenshot-success', true, '');
      }
    },
    beforeShot(preview) {
      //截图支持qrcode自定义颜色 由于html2canvas不支持CSS变量做了一下兼容
      for (let element of preview.getElementsByTagName('*')) {
        if (!element.id) continue;
        if (element.className.indexOf('widget-qr-code') !== -1) {
          const style = getComputedStyle(element);
          const qrcodeBg = style.getPropertyValue('--rocket-qrcode-bg').trim();
          const qrcodeFg = style.getPropertyValue('--rocket-qrcode-fg').trim();
          const svg = element.childNodes[0].getElementsByTagName('svg')[0];
          svg?.getElementsByTagName('path')[0]?.setAttribute('fill', qrcodeBg);
          svg?.getElementsByTagName('path')[1]?.setAttribute('fill', qrcodeFg);
        }
      }
    },
    handleTouchStart(e) {
      this.handleStopPropagation(e);
      this.timer && clearTimeout(this.timer);
      e.preventDefault();

      this.startTime = new Date().getTime();
      this.timer = setTimeout(() => {
        this.rocketEmit('rocket:system:long-touch-start', true);
        clearTimeout(this.timer);
      }, 300);
    },
    handleTouchEnd(e, type) {
      this.handleStopPropagation(e);
      this.timer && clearTimeout(this.timer);

      this.endTime = new Date().getTime();
      let interval = this.endTime - this.startTime;
      if (interval > 300) {
        this.rocketEmit('rocket:system:long-touch-end', true);
      } else {
        if (type == 'touch') {
          this.handleTap(e);
        }
      }
    },
    loadLazyImages() {
      if (this.watchImages?.size) {
        this.clearWatchImages();
      }
      this.loadedImages = new Set(); // 已加载的图片
      this.wantImages = new Set(); // 欲加载的图片
      this.watchImages = new Set(); // 监听加载的图片
      const wantImages = this.wantImages;
      const $imgs = this.$el.querySelectorAll('.widget-image');
      const loadedImages = new Set();
      $imgs.forEach((item) => {
        if (!item.querySelector('.v-lazy-image')) return;

        const id = item.getAttribute('id');

        if (wantImages.has(id)) return;
        wantImages.add(id);
        // 已加载完成
        if (item.querySelector('.v-lazy-image-loaded')) {
          loadedImages.add(id);
        } else {
          // 开启监听
          let imgNodeId = item.getAttribute('node-id');
          if (!imgNodeId) imgNodeId = item.getAttribute('id');

          if (!this.watchImages.has(imgNodeId)) {
            this.watchImages.add(imgNodeId);
            this.$bus.$on(
              'rocket:image:lazy-load-success:' + imgNodeId,
              this.afterLoadImage
            );
          }
          // 触发加载
          this.$bus.$emit(
            'rocket:node:trigger:' + imgNodeId,
            'rocket:image:lazy-load',
            { id }
          );
        }
      });
      if (loadedImages.size) {
        for (const item of loadedImages) {
          this.afterLoadImage({ id: item });
        }
      }
    },
    afterLoadImage(e) {
      const imageId = e.id;
      if (!this.wantImages.has(imageId)) return; // 没在期待图片列表中
      if (this.loadedImages.has(imageId)) return;
      this.loadedImages.add(imageId);
      const t1 = this.loadedImages.size;
      const t2 = this.wantImages.size;
      const progress = Math.ceil((t1 * 100) / t2);
      this.rocketEmit('rocket:node:lazy-load-progress', true, progress);
      if (t1 === t2) {
        this.rocketEmit('rocket:node:lazy-load-complete', true);
        this.clearWatchImages();
      }
    },
    clearWatchImages() {
      const watchImages = [...this.watchImages];
      watchImages.forEach((i) => {
        this.$bus.$off(
          'rocket:image:lazy-load-success:' + i,
          this.afterLoadImage
        );
      });
      this.watchImages.clear();
      this.loadedImages.clear();
      this.wantImages.clear();
    },
  },
};
